module.exports = __webpack_public_path__ + "img/Transdport&Infrastructure.6789f632.png";